import { render, staticRenderFns } from "./terms-use.vue?vue&type=template&id=71d2d392&scoped=true&"
import script from "./terms-use.vue?vue&type=script&lang=js&"
export * from "./terms-use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2d392",
  null
  
)

export default component.exports